import { cn } from "@/lib/utils";
import { ClickToCopyId } from "./ClickToCopyId";

interface CopyableReferenceIdProps {
  label: string;
  value: string;
  previewLength?: number;
  className?: string;
}

export function CopyableReferenceId({
  label,
  value,
  previewLength = 8,
  className,
}: CopyableReferenceIdProps) {
  const preview =
    value.length > previewLength + 1
      ? `${value.slice(0, previewLength)}…`
      : value;

  return (
    <div className={cn("flex items-center justify-between gap-2 text-sm", className)}>
      <span className="shrink-0 text-surface-500">{label}</span>
      <ClickToCopyId
        value={value}
        displayValue={preview}
        className="min-w-0"
      />
    </div>
  );
}
